
const filterSelectors = {
  toggleBtn: '.js-filter-toggler',
  closeFilter: '.js-close-menu'
}

const filterClasses = {
  toggleClass: 'active-filter--right',
  overflowClass: 'overflow-hidden-filter'
}

$(document).on('click', filterSelectors.toggleBtn, function(event){
  event.preventDefault();

  $('body').toggleClass(`${filterClasses.overflowClass} ${filterClasses.toggleClass}`);

  $('html, body').animate({
    scrollTop: 0
  }, 0);
});

$(document).on('click', filterSelectors.closeFilter, () => {
  $('body').removeClass(`${filterClasses.overflowClass} ${filterClasses.toggleClass}`);
});
